exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.azure-configuration-component[data-v-4d06e25c] {\n  border: solid 1px #ccc;\n  border-radius: 5px;\n  padding: 1.5rem;\n  margin: 1rem 0;\n  background-color: white;\n}\n.skeleton[data-v-4d06e25c] {\n  border-color: rgb(217, 217, 217);\n  border-radius: 4px;\n  margin-top: 1rem;\n  height: 55px;\n  display: block;\n}\n", ""]);

// exports
